import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SideNav } from './components/SideNav';
import Header from './components/Header';
import { Box } from "@mui/system";
import Container from "@mui/material/Container";
import GlobalStyles from "@mui/material/GlobalStyles";
import useAuth from './pages/login/hooks';
import { Typography } from '@mui/material';
const Layout = () => {
    const { getUserDetail } = useAuth();
    const [navCollapsed, setNavCollapsed] = React.useState(true);
    const location = useLocation();
    const handleToggleNav = () => {
        setNavCollapsed(!navCollapsed);
    };
    useEffect(() => {
        getUserDetail()
    }, [])

    const isStudyRoute = location.pathname === "/study";

    // 🔑 disable Ctrl+C, Ctrl+V, Ctrl+A globally
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && ["c", "x", "a"].includes(e.key.toLowerCase())) {
                e.preventDefault();
                console.log(`Blocked Ctrl+${e.key.toUpperCase()}`);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    // 🖱 disable right click globally
    useEffect(() => {
        const handleRightClick = (e) => {
            e.preventDefault();
            console.log("Right click disabled");
        };

        window.addEventListener("contextmenu", handleRightClick);
        return () => {
            window.removeEventListener("contextmenu", handleRightClick);
        };
    }, []);

    return (
        <div style={{ userSelect: "none" }} className="layout">
            <Header onToggleNav={handleToggleNav} navCollapsed={navCollapsed} />
            <div className="content">
                <SideNav collapsed={navCollapsed} handleToggle={handleToggleNav} />
                <main>
                    <GlobalStyles
                        styles={{
                            body: {
                                "--MainNav-height": "56px",
                                "--MainNav-zIndex": 1000,
                                "--SideNav-width": "70px",
                                "--SideNav-zIndex": 1100,
                                "--MobileNav-width": "320px",
                                "--MobileNav-zIndex": 1100,
                            },
                        }}
                    />
                    <Box
                        sx={{
                            bgcolor: "#F6F7FB",
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            minHeight: "calc(100vh - 66px)",
                        }}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                flex: "1 1 auto",
                                flexDirection: "column",
                                justifyContent: 'space-between',
                                pl: { xs: 0, md: navCollapsed ? "70px" : "200px" },
                                transition: "padding-left 0.3s",
                            }}
                        >
                            {isStudyRoute ? (
                                <Outlet />
                            ) : (
                                <Container maxWidth="100%" sx={{ padding: '15px !important', paddingBottom: '40px !important' }}>
                                    <Outlet />
                                </Container>
                            )}
                            <Box sx={{
                                background: '#EBF1F5',
                                width: "100%",
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                py: '4px',
                                zIndex: 2,
                                position: "fixed",
                                bottom: 0,
                                left: 0
                            }}>
                                <Typography
                                    sx={{
                                        fontSize: { xs: '0.6em', sm: '0.7em', md: '0.8em', lg: '0.9em' },
                                        fontWeight: 500,
                                        fontFamily: '"Quicksand", sans-serif',
                                    }}
                                >
                                    © 2024 Azvasa.in | All Rights Reserved.
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </main>
            </div>
        </div>
    );
};
export default Layout;